function getRoutes({ schema, ProtectedRoute, BubbleRouteError, Pages }) {
  if (!schema || !Array.isArray(schema)) {
    return [];
  }

  const routes = schema.map(route => {
    const { path, children = null, element } = route;

    return {
      path,
      ...(element && { element: Pages[element] || null }),
      errorElement: <BubbleRouteError />,
      ...(children && {
        children: getRoutes({
          schema: children,
          ProtectedRoute,
          BubbleRouteError,
          Pages,
        }),
      }),
    };
  });
  return routes;
}

export default getRoutes;
